import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

function initializeApp() {
  // Find root element
  const container = document.getElementById('root');
  if (!container) {
    console.error('Root element not found');
    return;
  }

  // Create root and render app
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  // Remove loading class from document element after render
  requestAnimationFrame(() => {
    document.documentElement.classList.remove('loading');
  });
}

// Add loading class to document element
if (document.documentElement) {
  document.documentElement.classList.add('loading');
}

// Initialize based on document readiness
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}

// Global error handlers
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});